(function() {
  'use strict';
  
  angular
    .module('app.myPolls')
    .controller('ManageCollaboratorsController', ManageCollaboratorsController);
      
  ManageCollaboratorsController.$inject = [
    '$log', 
    '$mdDialog',
    '$state',
    'auth',
    'myPollsService',
    'collection',
  ];
    
  function ManageCollaboratorsController(
      $log, 
      $mdDialog,
      $state,
      auth,
      myPollsService,
      collection
    ) {
    $log = $log.getInstance('ManageCollaboratorsController');

    /* jshint validthis: true */
    var vm = this;
    
    vm.action = null;
    vm.addOwner = addOwner;
    vm.addOwnerSelectedUser = null;
    vm.addOwnerText = null;
    vm.cancel = cancel;
    vm.collection = {
      _id: collection._id,
      name: collection.name,
      owners: _.sortBy(collection.owners, function(o) { 
        return o.name.first + o.name.last; 
      })
    };
    vm.collections = null;
    vm.removeOwner = removeOwner;
    vm.save = save;
    vm.searchUsers = searchUsers;
    vm.serverErrors = {};
    vm.user = auth.user();
    vm.alertMessage = '';
    vm.removedSelf = false;

    activate();

    function activate () {
      myPollsService.getCollections()
        .then(function(collections){
          vm.collections = collections
        });
    }

    function addOwner(user) {
      if (!user)
        return;
      vm.alertMessage = '';
      var i = _.sortedIndex(vm.collection.owners, user, function(o) {
        return o.name.first + o.name.last;
      });
      if (user._id === vm.user._id)
        vm.removedSelf = false
      vm.collection.owners.splice(i, 0, user);
      vm.addOwnerSelectedUser = null;
      vm.addOwnerText = null;
    }
    
    function removeOwner(owner) {
      if (vm.collection.owners.length < 2)
        vm.alertMessage = 'Collections need at least one collaborator.';
      else {
        if (owner._id === vm.user._id) {
          vm.alertMessage = 'You have removed yourself from this collection - your collaborators will still have access.';
          vm.removedSelf = true;
        }
        vm.collection.owners.splice(
          vm.collection.owners.indexOf(owner),
          1
        );
      }
    }
    
    function searchUsers(phrase) {
      return myPollsService.searchUsers(phrase, 'poller')
        .then(function(users) {
          var ownerIds = _.pluck(vm.collection.owners, '_id');
          var list = _.chain(users)
            .filter(function(user) {
              return !_.contains(ownerIds, user._id);
            })
            .sortBy(function(user) {
              var weight = 0
              var startsWith = new RegExp('^' + phrase.replace(/\s+/g, '|'), 'i')
              if (user.name.first.match(startsWith)) weight++
              if (user.name.last.match(startsWith)) weight++
              if (user.username.match(startsWith)) weight++
              return -weight
            })
          return list.value()
        })
        .catch(function(err) {
          if (err.code && err.code === 404)
            return [];
        });
    }
    
    function save() {
      vm.action = 'Saving';
      collection.owners = vm.collection.owners;
      myPollsService.updateCollection(collection, 'owners')
        .then(function() {
          myPollsService.cascadeOwners(collection)
          vm.action = null;
          $mdDialog.hide(collection)
            .then(function() {
              if (vm.removedSelf) {
                var collectionIndex = _.indexOf(vm.collections, collection);
                vm.collections.splice(collectionIndex, 1);
                $state.go('shell.myPolls.upcoming');
              }
            })
        })
        .catch(function(err) {
          vm.serverErrors[err.code] = true;
          vm.action = null;
        });
    }

    function cancel() {
      $mdDialog.cancel();
    }

  }
  
})();